<div class="pe-header"
     [ngStyle]="{backgroundColor:header.bgColor,
         paddingLeft:header.paddingOnSides + 'px',
         paddingRight:header.paddingOnSides  + 'px'}">
  <ng-content>
  </ng-content>
  <div class="pe-c-container" [ngStyle]="{'maxWidth':layoutSetting.maxWidth + 'px'}">

    <nav [ngStyle]="{color:header.colorLink}">
      <div class="pe-h-logo">
        <img alt="logo" [attr.src]="header.logo" />
      </div>
      <ul>
        <li>
          <a (click)="goTo([ '/', this.storeUrl ])">Home</a>
        </li>
        <li><a (click)="goTo([  this.storeUrl,'products'])">Products</a></li>

        <li *ngIf="this.user.userRole === 'EndUser'">
          <a [routerLink]="[  '/', this.storeUrl,'orders' ]" [routerLinkActive]="['active-link']" [routerLinkActiveOptions]="{exact:
                true}">Order</a>
        </li>
        <li *ngIf="this.user.userRole === 'EndUser'">
          <a [routerLink]="[  '/',this.storeUrl, 'wishlist' ]" [routerLinkActive]="['active-link']" [routerLinkActiveOptions]="{exact:
                true}">Wishlist</a>
        </li>
        <li *ngIf="this.user.userRole === 'EndUser' && CanEndUserCustomize == 'true'">
          <a [routerLink]="[  '/', this.storeUrl,'saveddesigns' ]" [routerLinkActive]="['active-link']" [routerLinkActiveOptions]="{exact:
                  true}">Saved Designs</a>
        </li>
     
      </ul>
      <ul class="pe-h-right">
        <li>
          <a   (click)="goTo([  this.storeUrl , 'cart' ])">
            <app-cart [color]="header.colorLink"></app-cart>
            <span class="badge badge-cart">{{this.user.CartItemCount}}</span>
          </a>-
        </li>
        <li *ngIf = "!this.user.isLoggedIn && (this.user.userRole != 'StoreAdmin' && this.user.userRole != 'StoreOwner' && this.user.userRole != 'StoreStaffMember') && this.user.userRole != 'SuperAdmin'" style="cursor: pointer;">
          <a (click)="executeLogic?openLoginDialog():null">
            <span  class="d-none d-md-block"> Login & Register</span>
            <i class="fa fa-bars d-md-none" aria-hidden="true"></i>
          </a>
        </li>
        <li class="dropdown-link"  *ngIf="this.user.userRole == 'EndUser'">
          <a>
            <img class="pe-h-img" [src]="user.ProfileImage" alt="">
            <span class="pe-h-username">{{user.FullName}}</span>
          </a>
          <ul  [ngStyle]="{backgroundColor:header.bgColor}" style="z-index:5">
            <li><a  [routerLink]="[ 'profile' ]">Account</a></li>
            <li><a (click)="logout()">Log Out</a></li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</div>
